import { ref } from 'vue';
import { httpInstance } from '@/clients/http.request';
import { urlBsa } from '@/helpers';

const POLL_INTERVAL_MS = 5 * 60 * 1000;

const total = ref(0);
const items = ref([]);
const loading = ref(false);
const error = ref(null);

let pollTimer = null;

async function fetchNotifications() {
   loading.value = true;
   error.value = null;
   try {
      const { data } = await httpInstance.get(`${urlBsa}/notificaciones-par`);
      total.value = data?.total ?? 0;
      items.value = Array.isArray(data?.items) ? data.items : [];
   } catch (err) {
      error.value = err;
      // Mantener último estado conocido
   } finally {
      loading.value = false;
   }
}

function refresh() {
   return fetchNotifications();
}

function startPolling() {
   stopPolling();
   pollTimer = setInterval(fetchNotifications, POLL_INTERVAL_MS);
}

function stopPolling() {
   if (pollTimer) {
      clearInterval(pollTimer);
      pollTimer = null;
   }
}

export function useParNotifications() {
   return {
      total,
      items,
      loading,
      error,
      fetchNotifications,
      refresh,
      startPolling,
      stopPolling,
   };
}
